import { apiPost, apiGet, apiDelete, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getWeightTolerancesAPI = () => {
  return apiGet('mgmt/tolerances')
}

export const addWeightToleranceAPI = (data) => {
  Hotjar.event('add_weight_tolerance')
  return apiPost('mgmt/tolerances', data)
}

export const updateWeightToleranceAPI = (data) => {
  Hotjar.event('update_weight_tolerance')
  return apiPut(`mgmt/tolerances/${data.id}`, data)
}

export const deleteWeightToleranceAPI = (toleranceId) => {
  Hotjar.event('delete_weight_tolerance')
  return apiDelete(`mgmt/tolerances/${toleranceId}`)
}

export const enableWeightToleranceAPI = (toleranceId, data) => {
  Hotjar.event('enable_weight_tolerance')
  return apiPost(`mgmt/tolerances/${toleranceId}/enable`, data)
}



// WEBPACK FOOTER //
// ./src/api/weightTolerance.js